import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { type AdyenPaymentModuleSpecsFragment } from '../../../../api/fragments/AdyenPaymentModuleSpecs';
import NoItemResult from '../../../../components/results/NoItemResult';
import { useAdyenPaymentSettingsDrawer } from './AdyenPaymentSettingsDrawer';

export type AdyenPaymentSettingsEmptyListProps = {
    module: AdyenPaymentModuleSpecsFragment;
};

const AdyenPaymentSettingsEmptyList = ({ module }: AdyenPaymentSettingsEmptyListProps) => {
    const { t } = useTranslation(['adyenPaymentModuleDetails']);
    const addAdyenPaymentSettingsDrawer = useAdyenPaymentSettingsDrawer(module.id);

    return (
        <>
            <NoItemResult
                extra={
                    <Button onClick={addAdyenPaymentSettingsDrawer.open} type="primary">
                        {t('adyenPaymentModuleDetails:emptyList.paymentSettings.noData.action')}
                    </Button>
                }
                subTitle={t('adyenPaymentModuleDetails:emptyList.paymentSettings.noData.message')}
            />
            {addAdyenPaymentSettingsDrawer.render()}
        </>
    );
};

export default AdyenPaymentSettingsEmptyList;
